import { __decorate, __metadata } from "tslib";
import { StoreItemTypeEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsIn, IsInt, IsNotEmpty, IsOptional, IsPositive, IsString, MaxLength, Min, MinLength } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
export class ReadStoreItemComboPropertyDto {
}
__decorate([
    ApiProperty({ type: () => String, example: 'caa8b54a-eb5e-4134-8ae2-a3946a428ec7' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.BATCH_CREATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.CREATE, StoreItemsExposeGroup.UPDATE, StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsNotEmpty({ groups: [StoreItemsExposeGroup.BATCH_CREATE] }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "uid", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'Combo slot name' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsString({ always: true }),
    MinLength(1, { always: true }),
    MaxLength(100, { always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "name", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'edb098cc-dcb2-407e-a34e-b02a86d865ca' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsString({ always: true }),
    IsNotEmpty({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "targetUid", void 0);
__decorate([
    ApiProperty({ type: () => String, example: StoreItemTypeEnum.STORE_ITEM, enum: [StoreItemTypeEnum.STORE_ITEM, StoreItemTypeEnum.CATEGORY] }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsIn([StoreItemTypeEnum.STORE_ITEM, StoreItemTypeEnum.CATEGORY, StoreItemTypeEnum.STORE_ITEM_GROUP], { always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 1 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsInt({ always: true }),
    IsPositive({ always: true }),
    Min(1, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemComboPropertyDto.prototype, "quantity", void 0);
__decorate([
    ApiProperty({ type: () => Number, example: 1 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsInt({ always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], ReadStoreItemComboPropertyDto.prototype, "showOrder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'edb098cc-dcb2-407e-a34e-b02a86d865ca' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "defaultSelectedUid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, example: 'edb098cc-dcb2-407e-a34e-b02a86d865ca' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboPropertyDto.prototype, "posGuid", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true, description: 'Mark combo slot as optional' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadStoreItemComboPropertyDto.prototype, "isOptional", void 0);
//# sourceMappingURL=ReadStoreItemComboPropertyDto.js.map